import { Link } from 'react-router';
import { unitPath } from '../../fleet/features/units/units.paths';

/** A vehicle registration in DM Mono (`font-mono`); a truck's opens its unit in Fleet. */
export function Registration({ value, linksToUnit = false }: { value: string; linksToUnit?: boolean }) {
  if (!linksToUnit) return <span className="font-mono text-xs">{value}</span>;
  return (
    <Link to={unitPath(value)} className="font-mono text-xs text-primary hover:underline">
      {value}
    </Link>
  );
}
